import { isMemberImportPreviewResponse, } from '@urbanik/api-contracts';
export class MemberImportPreviewApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MemberImportPreviewApiError';
    }
}
export async function getMemberImportPreview(baseUrl, signal) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/member-import/preview`, {
            headers: { Accept: 'application/json' },
            credentials: 'include',
            signal: signal ?? null,
        });
    }
    catch {
        throw new MemberImportPreviewApiError('unavailable', 'No pudimos preparar la vista previa.');
    }
    if (response.status === 401)
        throw new MemberImportPreviewApiError('unauthorized', 'Debes iniciar sesión.');
    if (response.status === 403)
        throw new MemberImportPreviewApiError('forbidden', 'No tienes permiso.');
    const payload = await response.json();
    if (!response.ok || !isMemberImportPreviewResponse(payload))
        throw new MemberImportPreviewApiError('invalid', 'La vista previa no es válida.');
    return payload;
}
